import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import getClientText from "@/app/i18n";
import AlertDialogContext from "@/ContextProviders/AlertDialogContextProvider/AlertDialogContextProvider";

const AlertDialog = ({
  lang,
  setShowDialog,
  buttonType,
  isOpen,
  titleText,
  messageText,
  yesOkText,
  noText,
  cancelText,
  yesOkAction,
  noAction,
  cancelAction,
  ...props
}: {
  lang: string;
  setShowDialog?: any;
  buttonType: string;
  isOpen: boolean;
  titleText: string;
  messageText: string;
  yesOkText?: string;
  noText?: string;
  cancelText?: string;
  yesOkAction?: any;
  noAction?: any;
  cancelAction?: any;
}) => {
  const t = getClientText(lang, "common");

  //const [open, setOpen] = React.useState(isOpen);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const alertContext = React.useContext(AlertDialogContext);

  const handleClose = () => {
    alertContext.hideAlert();
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={isOpen}
        //onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          sx: {
            minWidth: { xs: 320, sm: 420 },
          },
        }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{ whiteSpace: "pre-line" }}
        >
          {titleText}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            style={{ textAlign: "center", whiteSpace: "pre-line" }}
          >
            {messageText}
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center", marginBottom: 10 }}>
          <Button
            style={{ backgroundColor: "green", color: "white" }}
            autoFocus
            onClick={() => {
              if (!yesOkAction) return handleClose();
              yesOkAction();
              //handleClose();
            }}
          >
            {yesOkText !== undefined
              ? yesOkText
              : buttonType !== "ok"
                ? t.btnYes
                : t.btnOK}
          </Button>
          <>
            {(buttonType === "yesno" || buttonType === "yesnocancel") && (
              <Button
                style={{ backgroundColor: "red", color: "white" }}
                onClick={() => {
                  if (!noAction) return handleClose();
                  noAction();
                  //handleClose();
                }}
              >
                {noText || t.btnNo}
              </Button>
            )}
            {buttonType === "yesnocancel" && (
              <Button
                style={{ backgroundColor: "orange", color: "white" }}
                onClick={() => {
                  if (!cancelAction) return handleClose();
                  cancelAction();
                  //handleClose();
                }}
              >
                {cancelText || t.btnCancel}
              </Button>
            )}
          </>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

AlertDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  titleText: PropTypes.string.isRequired,
  messageText: PropTypes.string.isRequired,
  buttonType: PropTypes.oneOf(["ok", "yesno", "yesnocancel"]).isRequired, // ระบุว่า buttonType ต้องเป็น 'a', 'b', 'c' เท่านั้น
};

export default AlertDialog;
